/* Scroll reveal for the Corestride sections: content below the fold fades and slides up as it enters the
   viewport, siblings (cards, reviews, list items) staggered by 80 ms. Content already on screen at load is never
   hidden, nothing animates for visitors who ask for reduced motion, and without IntersectionObserver the page
   simply renders as before. */
(() => {
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const selector = [
    '.cs-section .cs-eyebrow', '.cs-section .cs-heading', '.cs-section .cs-sub', '.cs-split__heading', '.cs-split__media',
    '.cs-split__note', '.cs-card', '.cs-review', '.cs-points__item', '.cs-numbered__item', '.cs-quote', '.cs-specs__media',
    '.cs-specs__row', '.cs-guarantee__box', '.cs-compare__table'
  ].join(',');
  const els = [...document.querySelectorAll(selector)].filter((el) => el.getBoundingClientRect().top > window.innerHeight);
  if (!els.length) return;
  document.documentElement.classList.add('cs-motion');
  const set = new Set(els);
  els.forEach((el) => {
    const siblings = [...el.parentElement.children].filter((child) => set.has(child));
    const index = siblings.indexOf(el);
    if (index > 0) el.style.setProperty('--cs-delay', `${Math.min(index, 5) * 80}ms`);
    el.classList.add('cs-reveal');
  });
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px' });
  els.forEach((el) => observer.observe(el));
})();
